// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const ArrowRightIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="ArrowRightIcon" ref={forwardedRef} {...props}>
      <path d="m17.25 10.01-6.01 6.01-1.062-1.06 4.186-4.187H2.75v-1.5h11.643l-4.21-4.216L11.24 4z" />
    </SvgIcon>
  );
});

/**
 * Use for navigate to another internal page or show direction
 * @public
 */
export const ArrowRightIcon = /* @__PURE__ */ Object.assign(
  ArrowRightIconComponent,
  { displayName: 'ArrowRightIcon' },
);
